<!-- Copyright The Linux Foundation and each contributor to LFX. -->
<!-- SPDX-License-Identifier: MIT -->
<div class="radiogroup-wrapper {{ type }} {{ classNames }}"
     [ngClass]="{'dynamic': type === 'dynamic' && options.length > 7}">
       <div *ngFor="let option of options; trackBy: trackOptions"
            class="custom-control custom-radio mb-3 mr-4">
              <input name="{{ name }}"
                     class="custom-control-input"
                     id="{{ name }}_{{ option.id || option }}"
                     type="radio"
                     (change)="onSelect(option)"
                     [disabled]="option.disabled"
                     [attr.checked]="selected && (option === selected || (option.id && option.id === selected.id)) ? '' : null">
              <label class="custom-control-label"
                     for="{{ name }}_{{ option.id || option }}">{{ option.name || option }}</label>
       </div>

</div>


// WEBPACK FOOTER //
// ./src/app/access-management/radio-select/radio-select.component.html